export default __webpack_public_path__ + "static/media/img5.fe1cdc3f.png";